import React, { useState } from "react";
import Button from "../../components/btn/Button";
import PageHeading from "../../components/PageHeading";
import {
  BackButton,
  DownloadButton,
  HelpButton,
} from "../../components/btn/Buttons";
import { useSelector } from "react-redux";
import RadioBtn from "../../components/radio/RadioBtn";
import { CheckBox } from "../../components/inputs/CheckBox";
import { summaryData } from "../../utils/data";
import Input from "../../components/inputs/Input";
import { get_day_summery_list } from "./DayendDaySlice";
import store from "../../redux/store";
import PageLoading from "../../components/PageLoading";
import Table from "../../components/table/Table";
import moment from "moment";
import NoData from "../../components/NoData";

const DaySummery = () => {
  const [show, setShow] = useState(false);
  const [selectLink, setSelectLink] = useState([]);
  const [dateData, setDateData] = useState({});
  const {
    day_summery_list,
    day_summery_loading,
    day_summery_date,
    day_summery_pdf,
    day_summery_excel,
  } = useSelector((state) => state.day_end);

  return (
    <div className="container">
      <PageHeading
        title={"DAY SUMMARY"}
        right={
          <>
            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/oEzSuwSIkRg",
                "https://youtu.be/rrX-pqA7h68",
              ]}
            />
          </>
        }
      />
      <div style={{ height: "20px" }} />
      <div>
        {show && (
          <p className="DayEndText">
            SUMMERY DATE :{" "}
            <b>{moment(day_summery_date).format("DD-MMM-YYYY")}</b>
          </p>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "20px",
          marginTop: "1rem",
          alignItems: "center",
        }}
      >
        <Input
          mw={"150px"}
          type={"date"}
          max={moment(new Date()).format("YYYY-MM-DD")}
          value={dateData?.date}
          disabled={day_summery_loading}
          onChange={(e) => {
            if (e.target.value.length <= 10) {
              setDateData((prev) => ({
                ...prev,
                date: e.target.value,
              }));
            }
          }}
        />
        <div
          style={{
            display: "flex",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <RadioBtn label={"Select List's "} />
          {summaryData.map((v, i) => (
            <CheckBox
              key={i}
              disabled={day_summery_loading}
              lable={v?.section?.toUpperCase()}
              Checked={selectLink?.includes(i + 1)}
              value={selectLink?.includes(i + 1)}
              onChange={() => {
                const data = selectLink?.filter((v) => v === i + 1);
                const data2 = selectLink?.filter((v) => v !== i + 1);
                if (data?.length > 0) {
                  setSelectLink(data2);
                } else {
                  setSelectLink([...selectLink, i + 1]);
                }
              }}
            />
          ))}
        </div>
        <Button
          disable={
            selectLink?.length === 0 || day_summery_loading || !dateData?.date
          }
          title={"GENERATE"}
          onClick={async () => {
            await store.dispatch(
              get_day_summery_list({
                ...dateData,
                selectLink: selectLink,
              })
            );
            setShow(true);
          }}
        />
      </div>
      {show && day_summery_excel && day_summery_pdf && (
        <DownloadButton
          mt={"20px"}
          side={"left"}
          pl={"20px"}
          excelDown={() => {
            window.open(day_summery_excel, "_blank");
            // downloadFile2(day_summery_excel,"naveen")
          }}
          PDFDown={() => {
            // downloadFile2(day_summery_pdf,"naveen")
            window.open(day_summery_pdf, "_blank");
          }}
        />
      )}
      {day_summery_loading ? (
        <PageLoading />
      ) : (
        <>
          {show &&
          summaryData?.every((value) => {
            const list = day_summery_list?.[value?.key];
            return !list || list.length === 0;
          }) ? (
            <NoData />
          ) : (
            <div>
              {summaryData?.map((v, i) => (
                <div className="mt10" key={i}>
                  {day_summery_list?.[v?.key]?.length > 0 && (
                    <>
                      <p className="DayEndText mt10">
                        {v?.section?.toUpperCase()} DETAILS
                      </p>
                      <Table
                        mt={5}
                        headData={Object.values(v?.data)}
                        body={day_summery_list?.[v?.key].map(
                          (val, ind, arr) => (
                            <tr key={ind}>
                              {/* Render normal columns */}
                              {Object.keys(v?.data)
                                // .slice(0, -1)
                                .map((key, index) => (
                                  <td key={index}>{val[key]}</td>
                                ))}
                            </tr>
                          )
                        )}
                      />
                    </>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DaySummery;
